import GenericSnack from '../components/GenericSnack';
import React from 'react';
import Content from '../components/Content';
import MainAuthorsList from '../components/main/authors/list/MainAuthorsList';

const MainAuthors = ({userStore, snackStore}) => {
  return (
    <Content title='Lista de Autores-pai' userStore={userStore}>
      <GenericSnack snackStore={snackStore} />
      <MainAuthorsList userStore={userStore} />
    </Content>
  );
};

export default MainAuthors;
